import script from "./TressSearchPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressSearchPopup.vue?vue&type=script&lang=ts&setup=true"

import "./TressSearchPopup.vue?vue&type=style&index=0&id=16ea1801&lang=scss"

const __exports__ = script;

export default __exports__